export enum Paths {
    ROOT = '/',
    CATEGORY_EXPLORER = '/kategori-utforsker',
    PRICE_FIELDS = '/prisfelter',
    PRICE_FIELD_TEMPLATES = '/prisfelt-maler',
    IMPORT_PRICE_FIELD_TEMPLATES = '/importer/mine-prisfelter/prisfelt-maler',
    PRICE_FIELD_TEMPLATE_SUGGESTIONS = '/forslag/prisfelt-maler',
    ROLES = '/roller',
    CREATE_ROLE = '/opprett-rolle',
    CREATE_PRICE_FIELD = '/opprett-prisfelt',
    CREATE_PRICE_FIELD_TEMPLATE = '/opprett-prisfelt-mal',
    CREATE_PRICE_FIELD_TEMPLATE_SUGGESTION = '/forslag/opprett-prisfelt-mal',
    OFFER = '/anbud',
    OFFER_DRAFTS = '/utkast/anbud',
    CREATE_OFFER = '/opprett-anbud',
    DASHBOARD = '/startside',
    ORG_USERS = '/org-brukere',
    ORGS = '/organisasjoner',
    CREATE_ORG_USER = '/opprett-org-brukere',
    APP_USERS = '/app-brukere',
    MY_ORG = '/min-organisasjon',
    MY_ORG_OFFER_TERMS = '/min-organisasjon/informasjon-i-anbud',
    MY_ORG_USER = '/min-org-bruker',
    MY_APP_USER = '/min-app-bruker',
    OWN_HELP_MESSAGES = '/hjelp/meldinger/mine-meldinger',
    HELP_MESSAGES = '/hjelp/meldinger',
    SELECT_ORG = '/velg-organisasjon',
}